import '../css/app.css'
import Vue from 'vue'
import Axios from 'axios'
import QS from 'qs'
import {
  VsaList,
  VsaItem,
  VsaHeading,
  VsaContent,
  VsaIcon
} from 'vue-simple-accordion'

import VDialogContact from '../vue/VDialogContact.vue'

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  data () {
    return {
      menu: false,
      contactName: null,
      contactPhone: null,
      contactEmail: null,
      contactStreet: null,
      contactCity: null,
      contactPostCode: null,
      contactNote: null,
      termsAgreed: null,
      formSent: false,
      simpleContactSent: false,
      contactSending: false,
      products: [],
      formService: null
    }
  },
  components: {
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent,
    VsaIcon,
    VDialogContact
  },
  methods: {
    toggleMenu () {
      this.menu = !this.menu
    },
    /**
     * Send simple contact form with reCAPTCHA
     */
    submitSimpleContact () {
      // A second click while reCAPTCHA or the request runs would send a duplicate inquiry.
      if (this.contactSending) return
      this.contactSending = true
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute('6LeA-LAqAAAAAIPA798aFTV1-_e8qMQ-35Zjz-0F', { action: 'submit' }).then((token) => {
          Axios.post('/nezavazna-poptavka', QS.stringify({
            contactPhone: this.contactPhone,
            recaptchaToken: token
          }))
            .then(() => {
              this.contactPhone = null
              window.location.href = '/dekujeme-za-poptavku'
            })
            .catch((err) => {
              const msg = err.response && err.response.data && err.response.data.message
              alert(msg || 'Nastala chyba při odeslání kontaktního formuláře')
              this.simpleContactSent = false
              this.contactSending = false
            })
        })
      })
    },
    /**
     * Send contact form with reCAPTCHA
     */
    submitContact () {
      // A second click while reCAPTCHA or the request runs would send a duplicate inquiry.
      if (this.contactSending) return
      this.contactSending = true
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute('6LeA-LAqAAAAAIPA798aFTV1-_e8qMQ-35Zjz-0F', { action: 'submit' }).then((token) => {
          Axios.post('/kontakt', QS.stringify({
            contactName: this.contactName,
            contactPhone: this.contactPhone,
            contactEmail: this.contactEmail,
            contactStreet: this.contactStreet,
            contactCity: this.contactCity,
            contactPostCode: this.contactPostCode,
            contactNote: this.contactNote,
            contactService: this.formService,
            recaptchaToken: token
          }))
            .then(() => {
              this.contactName = null
              this.contactPhone = null
              this.contactEmail = null
              this.contactStreet = null
              this.contactCity = null
              this.contactPostCode = null
              this.contactNote = null
              this.formSent = true
              window.location.href = '/dekujeme-za-poptavku'
            })
            .catch((err) => {
              const msg = err.response && err.response.data && err.response.data.message
              alert(msg || 'Nastala chyba při odeslání kontaktního formuláře')
              this.formSent = false
              this.contactSending = false
            })
        })
      })
    }
  },
  computed: {
    isContactDisabled () {
      return !this.termsAgreed || this.contactSending
    },
    isSimpleContactDisabled () {
      return !this.contactPhone || this.contactSending
    }
  }
})
